import type { LoaderFunction, LoaderFunctionArgs } from "react-router-dom";

/**
 * Runs multiple loaders sequentially, stopping early if a Response is returned.
 * Merges results by returning the latest non-Response value.
 */
export function composeLoaders<T extends LoaderFunction[]>(
  ...loaders: T
): LoaderFunction<
  Awaited<ReturnType<T[number]>> extends Response
    ? Response
    : Awaited<ReturnType<T[number]>>
> {
  return async (args: LoaderFunctionArgs) => {
    let result: Awaited<ReturnType<T[number]>> | null = null;

    for (const loader of loaders) {
      if (result instanceof Response) {
        return result; // stop if redirect or error Response
      }
      result = (await loader(args)) as Awaited<ReturnType<T[number]>>;
    }

    return result as unknown;
  };
}
